import type { Bounds, Vec2 } from '@/types';

/** Normalises two drag corners into a well-formed bounds. */
export const marqueeBounds = (start: Vec2, end: Vec2): Bounds => ({
  minX: Math.min(start.x, end.x),
  minY: Math.min(start.y, end.y),
  maxX: Math.max(start.x, end.x),
  maxY: Math.max(start.y, end.y),
});

/** A marquee smaller than this is treated as a click, not a selection. */
export const MARQUEE_MIN_SIZE = 4;

export const isMeaningfulMarquee = (b: Bounds): boolean =>
  b.maxX - b.minX >= MARQUEE_MIN_SIZE || b.maxY - b.minY >= MARQUEE_MIN_SIZE;
